export default __webpack_public_path__ + "static/media/video.b812e3be.mp4";